define('SuiteDynamics.PDPImageGalleryGrid.ImageGallery.View',
    [
        'underscore',
        'Backbone.View',
        'SC.Configuration',
        'Profile.Model',
        'Utils',
        'suitedynamics_pdpimagegallerygrid_imagegallery.tpl'
    ],
    function (
        _,
        BackboneView,
        Configuration,
        ProfileModel,
        Utils,
        template
    )
{
    'use strict';

    return BackboneView.extend({
        template: template,

        initialize: function (options) {
            BackboneView.prototype.initialize.apply(this, arguments);

            this.model = options.container.layout._currentView.model;
            this.images = this._getImages() || [];

            this._listenToModelChanges();
        },

        _listenToModelChanges: function () {
            this.model.on('change', this._handleModelChange, this);
        },

        _handleModelChange: function () {
            var newImages = this._getImages();
            if (!_.isEqual(this.images, newImages)) {
                this.images = newImages;
                this.render();
            }
        },

        _getImages: function () {
            var result = [];
            var itemImagesDetail = this._getItemImagesDetail();

            itemImagesDetail = itemImagesDetail.media || itemImagesDetail;

            var infographicKey = Configuration.get('imageGalleryGrid.infographicsImageKey', 'infographics');
            var imageFilters = Configuration.get('productline.multiImageOption', []);
            var infographicImages = this._getInfographicImages(itemImagesDetail);

            itemImagesDetail = this._filterImages(itemImagesDetail, imageFilters);

            var imagesToFlatten = _.omit(itemImagesDetail, infographicKey);

            var filteredImages = Utils.imageFlatten(imagesToFlatten);

            var filterApplied = this._isFilterApplied(imageFilters);
            if (filterApplied) {
                filteredImages = filteredImages.slice(0, 4);
                result = filteredImages.concat(infographicImages).slice(0, 6);
            } else {
                result = filteredImages.concat(infographicImages);
            }

            result = this._moveInfographicsToEnd(result, infographicImages);

            if (result.length > 1) {
                result = this._prioritizeFirstImage(result);
            }

            return result.length
                ? result
                : [{
                    url: Utils.getThemeAbsoluteUrlOfNonManagedResources(
                        'img/no_image_available.jpeg',
                        Configuration.get('imageNotAvailable')
                    ),
                    altimagetext: this.model.get('_name')
                }];
        },

        _getItemImagesDetail: function () {
            var item = this.model.get('item');
            return item && item.get('itemimages_detail') || {};
        },

        _getInfographicImages: function (itemImagesDetail) {
            var infographicKey = Configuration.get('imageGalleryGrid.infographicsImageKey', 'infographics');
            var insertsConfig = Configuration.get('insertsExtension.insertsConfiguration', []);
            var shoeType = (this.model.get('item') && this.model.get('item').get('class')) || '';
            var customerSegmentation = this._isB2B() ? 'B2B' : 'B2C';
            var inserts = _.where(insertsConfig, { customersegmentation: customerSegmentation, shoetype: shoeType }) || [];
            var availableInserts = _.compact(_.pluck(inserts, 'insertid'));
            var infographics = itemImagesDetail[infographicKey];

            if (!infographics) {
                return [];
            }

            var shoeBreakoutImages = infographics.urls || [];
            var allValidInsertImages = [];

            _.each(infographics, function (val, key) {
                if (key !== 'urls' && val && val.urls && _.contains(availableInserts, key)) {
                    allValidInsertImages = allValidInsertImages.concat(val.urls);
                }
            });

            var selectedInsertInternalId = this.model.get('custcol_ano_inserts_internalid') || '';
            var infographicImages = [];

            if (!selectedInsertInternalId) {
                infographicImages = allValidInsertImages;
            } else if (_.contains(availableInserts, selectedInsertInternalId)) {
                var selectedInsertImages = (infographics[selectedInsertInternalId] && infographics[selectedInsertInternalId].urls) || [];
                infographicImages = shoeBreakoutImages.concat(selectedInsertImages);
            } else {
                infographicImages = shoeBreakoutImages;
            }

            return infographicImages;
        },

        _filterImages: function (itemImagesDetail, imageFilters) {
            var self = this;
            var imagesContainer = itemImagesDetail;

            _.each(imageFilters, function (imageFilter) {
                var selectedOption = self.model.get('options').findWhere({ cartOptionId: imageFilter });

                if (
                    selectedOption &&
                    selectedOption.get('value') &&
                    selectedOption.get('value').label
                ) {
                    var filterLabel = selectedOption.get('value').label.toLowerCase();
                    _.each(imagesContainer, function (value, key) {
                        if (key.toLowerCase() === filterLabel) {
                            imagesContainer = value;
                        }
                    });
                }
            });

            return imagesContainer;
        },

        _isFilterApplied: function (imageFilters) {
            var self = this;
            return _.some(imageFilters, function (imageFilter) {
                var selectedOption = self.model.get('options').findWhere({ cartOptionId: imageFilter });
                return selectedOption && selectedOption.get('value') && selectedOption.get('value').label;
            });
        },

        _moveInfographicsToEnd: function (result, infographicImages) {
            var nonInfographics = _.filter(result, function (image) {
                return !_.find(infographicImages, function (infographic) {
                    return image.url === infographic.url;
                });
            });

            return nonInfographics.concat(infographicImages);
        },

        _prioritizeFirstImage: function (images) {
            var firstImage = this._getFirstImage(images);
            return _.union([firstImage], _.without(images, firstImage));
        },

        _getFirstImage: function (images) {
            return _.find(images, function (image) {
                var urlParts = image.url.split('.');
                return urlParts[urlParts.length - 2] === 'default';
            }) || images[0];
        },

        _isB2B: function() {
            var profileModel = ProfileModel.getInstance();
            var isB2B = false;
            var isLoggedIn = profileModel.get('isLoggedIn') === 'T';

            if (isLoggedIn) {
                var profileCustomFields = profileModel.get('customfields') || [];
                var isB2BField = _.findWhere(profileCustomFields, { name: 'custentity_ano_is_b2b' });
                if (isB2BField && isB2BField.value && isB2BField.value === 'T') {
                    isB2B = true;
                }
            }

            return isB2B;
        },

        getContext: function () {
            return {
                imageResizeId: Utils.getViewportWidth() < 768 ? 'thumbnail' : 'main',
                images: this.images,
                oddImages: this.images.length % 2 !== 0,
                showMultipleImages: this.images.length > 1,
                firstImage: this.images[0] || {}
            };
        }
    });
});
